import React, { useEffect, useState } from 'react';
import userStore from '../Stores/User';
import { loadStripe } from "@stripe/stripe-js";
import { observer } from 'mobx-react';
import { createSubscriptionCheckoutSessionWithTrial } from "../audiblogsApi";
import { Link } from "react-router-dom";
// import loadingIcon from "../Assets/loading.gif";
import loadingIcon from "../Assets/loading.gif"
import mixpanel from "mixpanel-browser";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);


const Checkout = observer((props) => {
    const { logOut, idToken, isSignedIn, user, creditsHd } = userStore;
    const [sessionId, setSessionId] = useState(null);
    const [buttoMessage, setButtonMessage] = useState("Upgrade to Unlimited");

    const redirectToCheckout = () => {
        stripePromise.then((stripe) => {
            stripe
                .redirectToCheckout({
                    sessionId,
                })
                .then((handleResult) => {
                    console.log("handle results");
                    handleResult();
                })
                .catch((e) => {
                    console.log(e);
                });
        });
    };

    useEffect(() => {
        if (user !== null && user.subscriptions && !user.subscriptions.unreal) {
            const data = {
                metadata: {
                  initial_source: mixpanel.get_property('initial_source'),
                  initial_medium: mixpanel.get_property('initial_medium'),
                  initial_campaign: mixpanel.get_property('initial_campaign'),
                  initial_term: mixpanel.get_property('initial_term'),
                  landing_page: mixpanel.get_property('utm_landingpage'),
                  search_engine: mixpanel.get_property('$search_engine'),
                  search_keyword: mixpanel.get_property('mp_keyword'),
                  referrer: mixpanel.get_property('$referrer'),
                  initial_referrer: mixpanel.get_property('$initial_referrer'),
                  tolt_referral: window.tolt_referral
                }
              }
        
            createSubscriptionCheckoutSessionWithTrial(false, idToken, data)
                .then(function (data) {
                    setSessionId(data.data.sessionId);
                    if (data.data.trial) setButtonMessage("Start 7-Day Trial");
                })
                .catch((e) => {
                    console.log(e);
                    // alert("Something went wrong. Please try again or contact us.");
                });

        }
    }, [user]);

    return (
        (<>
            {/* {user && user.subscriptions && !user.subscriptions.unreal && sessionId && (
                <div className='cta-div-v2'>
                    <a
                        className="cta-button"
                        style={{ width: "auto" }}
                        onClick={(e) => {
                            e.preventDefault();
                            mixpanel.track("Click Go to Checkout");
                            redirectToCheckout();
                        }}
                    >
                        {buttoMessage}
                    </a>

                </div>
            ) } */}

        </>)
    );
});


export default Checkout;